<template>
  <div class="client-data_block">
    <p class="large_label">クライアント情報</p>
    <TableBox :is-with-header="false" :table-contents="clientData"/>
  </div>
</template>

<script>
  import TableBox from "@/components/molecules/box/TableBox";

  export default {
    name: "ClientDataTable",

    components: {TableBox},

    props: {
      client: {
        type: Object,
        required: true
      },
    },

    computed: {

      clientData() {
        return {
          total: {
            dt: '総合',
            dd: this.client && this.client.scores ? this.client.scores.total : '',
          },
          perfection: {
            dt: '作業指示の明快さ',
            dd: this.client && this.client.scores ? this.client.scores.accuracy : '',
          },
          speed: {
            dt: '契約金額適切さ',
            dd: this.client && this.client.scores ? this.client.scores.cost : '',
          },
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .client-data_block {
    .large_label {
      margin: 4rem 0 2rem 0;
    }

    .table_box {
      margin: 2rem 0;
      width: 100%;
    }
  }
</style>